import PropTypes from "prop-types";

export const listingSummary = PropTypes.shape({
  businessName: PropTypes.string.isRequired,
  street: PropTypes.string,
  suite: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postalCode: PropTypes.string,
  phoneNumber: PropTypes.arrayOf(PropTypes.string).isRequired,
  website: PropTypes.string,
  listingURL: PropTypes.string,
})

export const listing = PropTypes.shape({
  listingId: PropTypes.string,
  locationId: PropTypes.string,
  contentProvider: PropTypes.string,
  listingURL: PropTypes.string,
  listingBusinessId: PropTypes.string,
  description: PropTypes.string,
  // listingMatchInfo: Prop
  dateAdded: PropTypes.string,
  lastUpdated: PropTypes.string,
  // claimStatus
  expectedURL: PropTypes.string,
  foundURL: PropTypes.string,
  expectedLocation: listingSummary.isRequired, // missing the website, has to be pulled from the root
  foundLocation: listingSummary.isRequired, // missing the website, has to be pulled from the root
  // stats: PropTypes.any,
  categories: PropTypes.arrayOf(PropTypes.string),
  photoURLs: PropTypes.arrayOf(PropTypes.string),
  matchErrors: PropTypes.arrayOf(PropTypes.string),
  // score: PropTypes.any,
  // bbbRating: PropTypes.any,
  // managementCredentialIds: PropTypes.any,
  // ignoredMismatchTypes: PropTypes.any,
  // providerIds: PropTypes.any,
  // coordinates: PropTypes.any,
})

export const location = PropTypes.shape({
  locationId: PropTypes.string.isRequired,
  businessName: PropTypes.string,
  phoneNumber: PropTypes.arrayOf(PropTypes.string),
  website: PropTypes.arrayOf(PropTypes.string),
  businessAddress: PropTypes.shape({
    street: PropTypes.string,
    suite: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
    postalCode: PropTypes.string,
  })
})
